import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { createUserStorage } from './userStorage'

interface AdjustableTableState {
  preferences: Record<string, string[]>
  setPreference: (key: string, columns: string[]) => void
  getPreference: (key: string, defaultColumns: string[]) => string[]
}

export const useAdjustableTableStore = create<AdjustableTableState>()(
  persist(
    (set, get) => ({
      preferences: {},
      setPreference: (key, columns) =>
        set((state) => ({
          preferences: { ...state.preferences, [key]: columns },
        })),
      getPreference: (key, defaultColumns) =>
        get().preferences[key] ?? defaultColumns,
    }),
    {
      name: 'adjustable-table-preferences',
      storage: createUserStorage(),
    },
  ),
)

export const rehydrateAdjustableTableStore = () =>
  useAdjustableTableStore.persist.rehydrate()

export const resetAdjustableTableStore = () =>
  useAdjustableTableStore.setState({ preferences: {} })
